import React from 'react';
import { Users, ShieldAlert, DollarSign, FileCheck, HeartPulse } from 'lucide-react';
const services = [{
  title: 'Human Resources',
  description: 'Handle HR tasks more easily with our online platform and mobile app.',
  icon: Users
}, {
  title: 'Risk Management',
  description: 'Reduce risk and stay compliant with clear, reliable HR support.',
  icon: ShieldAlert
}, {
  title: 'Payroll',
  description: 'Track time, run payroll, and generate reports without added stress.',
  icon: DollarSign
}, {
  title: 'Regulatory Compliance',
  description: 'Keep up with changing tax, benefits, and employment regulations.',
  icon: FileCheck
}, {
  title: 'Employee Benefits',
  description: 'Offer competitive benefits to help attract and retain great employees.',
  icon: HeartPulse
}];
export function ServicesSection() {
  return <section className="py-16 bg-white" data-id="element-71">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-73">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-74">
            HR Taking Too Much Time?
          </h2>
          <p className="text-lg text-gray-600 mb-6" data-id="element-75">
            Payroll, compliance, benefits, and employee management can quickly
            become overwhelming.
          </p>
          <div className="inline-flex items-center gap-3 bg-navy text-white rounded-full py-4 px-6 shadow-md" data-id="element-76">
            <span className="w-2 h-2 bg-orange rounded-full flex-shrink-0" data-id="element-77"></span>
            <span className="text-lg font-semibold" data-id="element-78">
              KEENA PEO handles it all — so you don't have to.
            </span>
          </div>
        </div>

        {/* Top Row: 3 items */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-79">
          {services.slice(0, 3).map((service, index) => <div key={index} className="bg-white rounded-xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-80">
              <div className="w-14 h-14 bg-gray-50 rounded-lg flex items-center justify-center mb-6 border border-gray-100" data-id="element-81">
                <service.icon className="w-7 h-7 text-orange" data-id="element-82" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-83">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-84">
                {service.description}
              </p>
            </div>)}
        </div>

        {/* Bottom Row: 2 items centered */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-85">
          {services.slice(3, 5).map((service, index) => <div key={index} className="bg-white rounded-xl p-8 border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-86">
              <div className="w-14 h-14 bg-gray-50 rounded-lg flex items-center justify-center mb-6 border border-gray-100" data-id="element-87">
                <service.icon className="w-7 h-7 text-orange" data-id="element-88" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-89">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-90">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}